import { useState } from "react";
import { FaEye, FaEyeSlash, FaLock } from "react-icons/fa";
import "./profile.css";

// eslint-disable-next-line no-unused-vars
const REQUIREMENTS = [
  { key: "length", label: "At least 8 characters", test: (p) => p.length >= 8 },
  { key: "upper", label: "One uppercase letter", test: (p) => /[A-Z]/.test(p) },
  { key: "number", label: "One number", test: (p) => /[0-9]/.test(p) },
  { key: "symbol", label: "One special character", test: (p) => /[^A-Za-z0-9]/.test(p) },
];

export default function SecuritySettings({
  passwords, setPasswords, onSavePassword, savingPassword,
}) {
  const [pwErrors, setPwErrors] = useState({});
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const getPasswordStrength = (pass) => {
    if (!pass) return { level: 0, label: "", className: "" };
    let score = 0;
    if (pass.length >= 8) score++;
    if (pass.length >= 12) score++;
    if (/[A-Z]/.test(pass)) score++;
    if (/[0-9]/.test(pass)) score++;
    if (/[^A-Za-z0-9]/.test(pass)) score++;

    if (score <= 2) return { level: score, label: "Weak", className: "strength-weak" };
    if (score <= 3) return { level: score, label: "Fair", className: "strength-fair" };
    if (score <= 4) return { level: score, label: "Strong", className: "strength-strong" };
    return { level: score, label: "Very Strong", className: "strength-very-strong" };
  };

  const validatePassword = () => {
    const errs = {};
    if (!passwords.current) errs.current = "Current password is required";
    if (!passwords.newPass || passwords.newPass.length < 8) errs.newPass = "Minimum 8 characters required";
    if (passwords.newPass !== passwords.confirm) errs.confirm = "Passwords do not match";
    if (passwords.current && passwords.newPass === passwords.current) errs.newPass = "New password must be different from current";
    setPwErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSavePassword = async () => {
    if (!validatePassword()) return;
    await onSavePassword();
  };

  const strength = getPasswordStrength(passwords.newPass);

  return (
    <div className="account-card">
      <h2>Change Password</h2>

      {/* Premium hero banner */}
      {/* <div className="security-hero">
        <div className="security-hero-icon">
          <FaShieldAlt />
        </div>
        <div className="security-hero-text">
          <strong>Keep your account secure</strong>
          <span>Choose a strong password you haven't used before, and don't share it with anyone.</span>
        </div>
      </div> */}

      <div className="form-section-card security-section">
        <div className="section-title-premium"><FaLock /> Update Your Password</div>

        <div className="grid-2">
          <div className="account-field">
            <label>Current Password</label>
            <div className="account-password-wrapper">
              <input
                type={showCurrent ? "text" : "password"}
                value={passwords.current}
                placeholder="Enter current password"
                onChange={(e) => setPasswords({ ...passwords, current: e.target.value })}
              />
              <button type="button" className="account-password-toggle" onClick={() => setShowCurrent(!showCurrent)} tabIndex={-1}>
                {showCurrent ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
            {pwErrors.current && <span className="field-error">{pwErrors.current}</span>}
          </div>

          <div className="account-field">
            <label>New Password</label>
            <div className="account-password-wrapper">
              <input
                type={showNew ? "text" : "password"}
                value={passwords.newPass}
                placeholder="Enter new password"
                onChange={(e) => setPasswords({ ...passwords, newPass: e.target.value })}
              />
              <button type="button" className="account-password-toggle" onClick={() => setShowNew(!showNew)} tabIndex={-1}>
                {showNew ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
            {passwords.newPass && (
              <div className="password-strength">
                <div className="password-strength-bar">
                  <div className={`password-strength-fill ${strength.className}`} style={{ width: `${(strength.level / 5) * 100}%` }} />
                </div>
                <span className={`password-strength-label ${strength.className}`}>{strength.label}</span>
              </div>
            )}
            {pwErrors.newPass && <span className="field-error">{pwErrors.newPass}</span>}

            {/* Live requirement checklist */}
            {/* <ul className="security-hint-list">
              {REQUIREMENTS.map((req) => {
                const met = req.test(passwords.newPass || "");
                return (
                  <li key={req.key} className={met ? "met" : ""}>
                    {met ? <FaCheckCircle /> : <FaRegCircle />}
                    {req.label}
                  </li>
                );
              })}
            </ul> */}
          </div>
        </div>

        <div className="grid-2">
          <div className="account-field field-span-2">
            <label className="confirm">Confirm New Password</label>
            <div className="account-password-wrapper">
              <input
                type={showConfirm ? "text" : "password"}
                value={passwords.confirm}
                placeholder="Re-enter new password"
                onChange={(e) => setPasswords({ ...passwords, confirm: e.target.value })}
              />
              <button type="button" className="account-password-toggle" onClick={() => setShowConfirm(!showConfirm)} tabIndex={-1}>
                {showConfirm ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
            {pwErrors.confirm && <span className="field-error">{pwErrors.confirm}</span>}
          </div>
        </div>

        <button className="account-save-btn security-save-btn" onClick={handleSavePassword} disabled={savingPassword}>
          {savingPassword ? (
            <>
              <span className="btn-spinner" />
              Updating…
            </>
          ) : (
            "Update Password"
          )}
        </button>
      </div>
    </div>
  );
}